/**
 * I am just here for example purposes
 */

import { Stack } from "../../components";
import { useTranslation } from "../../language";

export const OtherWelcomePageComponent = () => {
	const translate = useTranslation();
	return (
		<Stack gap={20} horizontal horizontalAlign="center">
			<p style={
				{
					fontSize: "30px",
					paddingLeft: "75px",
					paddingRight: "75px",
					paddingBottom: "75px",
					textAlign: "center"
				}}>{translate("OtherWelcome.PressReceptionIfYoutWantHelp")}</p>
		</Stack>
	);
}